export const accountDict = {

    approveStatusMap: {
        '00': {color: "blue", label: "审批中", show: true},
        '01': {color: "green", label: "审批通过", show: true},
        '02': {color: "red", label: "审批驳回", show: true},
        default: {color: "#C7C7CC", label: "未知", show: false},
    },
    pushStatusMap: {
        '00': {color: "blue", label: "未推送", show: true},
        '01': {color: "green", label: "已推送", show: true},
        '02': {color: "red", label: "推送失败", show: true},
        default: {color: "#C7C7CC", label: "未知", show: false},
    },

};
